export const setStorage = (key, value, ttl = 86400000) => {
	const now = new Date()

	const item = {
		value: value,
		expiry: now.getTime() + ttl
	}

	window.localStorage.setItem(key, JSON.stringify(item))
}

export const getStorage = key => {
	const itemStr = window.localStorage.getItem(key)
	if (!itemStr) return null

	const item = JSON.parse(itemStr)
	const now = new Date()

	if (now.getTime() > item.expiry) return removeStorage(key)
	return item.value
}

export const removeStorage = key => {
	window.localStorage.removeItem(key)
	return null
}
